export default class PollutionSourceParameterDto {
    constructor(obj) {
        this.parameter = obj.parameter
        this.activityCode = obj.activityCode
        this.rate = obj.rate
    }
}